import React, { useState, useEffect } from 'react';
import './Video.scss';
import { IComponentVideo } from '../../component';
import ImageUtil from '../../utils/image';
import StatusTag from '../Tag/StatusTag';
import { IGalleryStatus } from '../../global.d';
import ComponentLink from '../ComponentLink';
import { IMediaListResult } from '../../actions/gallery';
import HeadVideo from '../ComponentXHead/HeadVideo';
import intl from 'react-intl-universal';

interface IVideo extends IComponentVideo {
  mediaList: IMediaListResult;
  showDialog: (params: any) => void;
}

const Video = function(props: IVideo) {
  const { cid, type } = props;
  const [theOne, setTheOne] = useState({});
  const [view, setView] = useState(0);

  const toVideoPage = function(data: IVideo) {
    // 当前页面播放，不需要跳转页面
    if (props.playin) {
      return;
    }
    const { status, videoid, source, type, islive } = data;
    const { link_id } = window.pageDetail;

    if (!islive) {
      if (status === IGalleryStatus.wait) {
        props.showDialog(intl.get('The live video is not started'));
        return;
      }
      if (status === IGalleryStatus.rollback) {
        props.showDialog(intl.get('The live video is waiting replay'));
        return;
      }
    }

    ComponentLink.to(`/g/${link_id}/video/${videoid}`);
  };
  // const [view, setView] = useState(0);
  let mediaListLength = 0;
  try {
    mediaListLength = props.mediaList.data.items.length;
  } catch (e) {
    // this.props.rootStore!.galleryStore.getLiveDetail(me.source).then(action((jsonData:any)=>{
    //   if(jsonData && jsonData.data) {
    //     let newList = [
    //       ...this.videoList
    //     ];
    //     newList = newList.map((it:any)=>{
    //       if(me && it.id == me.id) {
    //         it.type = jsonData.data.type;
    //         it.thumb = jsonData.data.cover_img;
    //         it.source = jsonData.data.play_url;
    //         it.second_url = jsonData.data.second_url;
    //         it.begin_at = jsonData.data.begin_at;
    //         it.end_at = jsonData.data.end_at;
    //       }
    //
    //       return it;
    //     });
    //
    //     this.videoList = newList;
    //     console.log(newList);
    //   }
    //
    //   setTimeout(this.autoPlayVideo, 500);
    // }));
  }

  useEffect(() => {
    if (mediaListLength) {
      const theOne = props.mediaList.data.items.find(
        media => +media.id === +props.videoid
      );
      if (theOne) {
        setTheOne(theOne);
        setView(theOne.view);
      }
    }
  }, [cid + type + mediaListLength]);
  return (
    <div className="video" onClick={toVideoPage.bind(null, props)}>
      <div className="video-poster-wrapper">
        <HeadVideo
          total={false}
          index={+props.videoid}
          disabled={!props.playin}
          showData={false}
          {...props}
          {...theOne}
        />
        <div className="view-row">
          {intl.get('View')} {view}
        </div>
      </div>

      <div className="title">{props.desc}</div>
    </div>
  );
};

export default Video;
